import {CHANNEL_INFO_BY_CHANNEL} from "./channels/channels";

export class AdAccountsActionDataHandler {
    // [{ad_account_id, ad_account_account_id, ad_account_name, channel, actions_selected: [action_id], "action_data":[{action_id, name}]
    constructor(data, t) {
        this.data = data;
        this.t = t;
    }

    filterForCampaignsConfiguration(buccId) {
        return new AdAccountsActionDataHandler(this.data.filter(adAccountActionData => (adAccountActionData["bucc_id"] === buccId)), this.t);
    }


    getAdAccountsSelectedItemsData() {
        // returns [{ad_account_id, ad_account_account_id, ad_account_name, channel, items: [name], empty_items_item:{"text":, "is_ok": False/True}]
        const adAccountsSelectedItemsData = [];

        this.data.forEach((adAccountData) => {
            const adAccountSelectedItemsData = {
                "bucc_id":  adAccountData["bucc_id"],
                "ad_account_id": adAccountData["ad_account_id"],
                "ad_account_account_id":  adAccountData["ad_account_account_id"],
                "ad_account_name": adAccountData["ad_account_name"],
                "channel": adAccountData["channel"],
                "items": this.getSelectedActionsNames(adAccountData["ad_account_id"]),
                "empty_items_item": this.getEmptyItemsItem(adAccountData["channel"])
            };
            adAccountsSelectedItemsData.push(adAccountSelectedItemsData);
        });

        return adAccountsSelectedItemsData;
    }

    getEmptyItemsItem(channel) {
        const isOkNoItems = CHANNEL_INFO_BY_CHANNEL[channel]["hasIncludeAllConversionsSetting"] === true;
        if (isOkNoItems)
            return {"text": this.t('ad_accounts_action_data_handler.all_primary_conversions'), "is_ok": true};
        else
            return {"text": this.t('ad_accounts_action_data_handler.no_events_selected'), "is_ok": false};
    }

    getDataOfAdAccountId(adAccountId) {
        return this.data.find(({ ad_account_id }) => ad_account_id === adAccountId);
    }

    getDataOfCampaignsConfigurationId(buccId) {
        return this.data.find(({ bucc_id }) => bucc_id === buccId);
    }

    getAllActionsOfAdAccount(adAccountId) {
        const adAccountData = this.getDataOfAdAccountId(adAccountId);
        if(adAccountData === undefined || adAccountData === null)
            return null;

        return adAccountData["action_data"] !== undefined ? adAccountData["action_data"] : [];
    }

    getAllActionsOfCampaignsConfiguration(buccId) {
        const buccData = this.getDataOfCampaignsConfigurationId(buccId);
        if(buccData === undefined || buccData === null)
            return null;

        return buccData["action_data"] !== undefined ? buccData["action_data"] : [];
    }

    getAdAccountsData() {
        return this.data.map((adAccountData) => ({
            "bucc_id":  adAccountData["bucc_id"],
            "ad_account_id": adAccountData["ad_account_id"],
            "ad_account_account_id": adAccountData["ad_account_account_id"],
            "ad_account_name": adAccountData["ad_account_name"],
            "channel": adAccountData["channel"]
        }));
    }

    getActionsNamesOfActions(adAccountId, actionsIds) {
        const actionNames = [];
        actionsIds.forEach(actionId => {
            const actionName = this.getNameOfAction(parseInt(adAccountId, 10), actionId);
            if(!actionNames.includes(actionName))
                actionNames.push(actionName);
        });
        return actionNames;
    }

    getActionsNamesOfActionsForCampaignsConfiguration(buccId, actionsIds) {
        const actionNames = [];
        actionsIds.forEach(actionId => {
            const actionName = this.getNameOfActionForCampaignsConfiguration(parseInt(buccId, 10), actionId);
            if(!actionNames.includes(actionName))
                actionNames.push(actionName);
        });
        return actionNames;
    }

    getSelectedActionsNames(adAccountId) {
        const adAccountData = this.getDataOfAdAccountId(adAccountId);
        const actionsIds = adAccountData["actions_selected"];
        return this.getActionsNamesOfActions(adAccountId, actionsIds);
    }

    getSelectedActionsNamesForCampaignsConfiguration(buccId) {
        const adAccountData = this.getDataOfCampaignsConfigurationId(buccId);
        const actionsIds = adAccountData["actions_selected"];
        return this.getActionsNamesOfActionsForCampaignsConfiguration(buccId, actionsIds);
    }

    getNameOfAction(adAccountId, actionIdSelected) {
        if(!this.data)
            return null;

        const adAccount = this.data.find(({ ad_account_id }) => ad_account_id === adAccountId);
        if (!adAccount)
            return null;  // Return early if the adAccountId is not found
        const action = adAccount.action_data !== null ? adAccount.action_data.find(({ action_id }) => action_id === actionIdSelected) : null;
        return action ? action.description : null;  // Return action name or null if not found
    }

    getNameOfActionForCampaignsConfiguration(buccId, actionIdSelected) {
        const adAccount = this.data.find(({ bucc_id }) => bucc_id === buccId);
        if (!adAccount)
            return null;  // Return early if the adAccountId is not found
        const action = adAccount.action_data !== null ? adAccount.action_data.find(({ action_id }) => action_id === actionIdSelected) : null;
        return action ? action.description : null;  // Return action name or null if not found
    }
}